// @flow

import * as React from 'react';
import { Component } from 'react';
import {Icon} from 'react-fa';
import Draggable from 'react-draggable';
import _ from 'lodash';

import {no_rclick} from './utils.js';

import './css/XDialog.css';



type T_XDialogProps = {
  name       : string,
  title      : string,
  father     : Object,
  drag       : boolean,
  state_ctl? : string,
  no_close?  : boolean,
  cond?      : boolean,
  style?     : Object,
  frame_drag?: boolean,
  toggleable?: boolean,
  children?  : React.Node,
  font       : string,
  huge_title?: boolean
};



type T_XDialogState = {
  toggled: boolean
};



export default class XDialog extends Component<T_XDialogProps, T_XDialogState> {
  static defaultProps = {
    no_close  : false,
    style     : {},
    cond      : true,
    frame_drag: true,
    state_ctl : ''
  };
  
  
  close : () => void;
  toggle: () => void;
  
  
  
  constructor(props: T_XDialogProps) {
    super(props);
    
    this.state = {
      toggled: false
    };
    
    this.close  = this.close.bind(this);
    this.toggle = this.toggle.bind(this);
  }
  
  
  
  close(): void {
    this.props.father.setState({[this.props.state_ctl || this.props.name]: null});
  }
  
  
  
  toggle(): void {
    if (this.props.toggleable) {
      this.setState({toggled: ! this.state.toggled});
    }
  }
  
  
  
  render() {
    if (_.has(this.props, 'cond') && ! this.props.cond) {
      return null;
    }
    
    if (! this.props.father.state[this.props.state_ctl || this.props.name]) {
      return null;
    }
    
    const
      huge = _.has(this.props, 'huge_title') && this.props.huge_title,
      cls_title = huge ? 'dtitle huge_title' : 'dtitle',
      sty_title = {cursor: (this.props.drag ? 'default' : 'move'), fontFamily: this.props.font},
      icon_size = huge ? {size: 'lg'} : {},
      cls_icon = huge ? 'huge_close' : 'icon_close';
    
    const content = (
      <div className={this.props.name} style={this.props.style} onContextMenu={no_rclick}>
        <p className={cls_title} style={sty_title} onDoubleClick={this.toggle}>
          {this.props.title} &nbsp;
        </p>
        
        <div className='dclose'>
          {(! this.props.no_close) &&
            <Icon name='times-circle' className={cls_icon} onClick={this.close} {...icon_size} />
          }
          
          {(! this.state.toggled) &&
            this.props.children
          }
        </div>
      </div>
    );
    
    return (
      (_.has(this.props, 'frame_drag') && ! this.props.frame_drag) ?
        content
      :
        <Draggable disabled={this.props.drag}>
          {content}
        </Draggable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/XDialog.jsx